import { GuidUserType } from './types';

function parseGuidList(guidString: string | undefined) {
  if (!guidString) return [];
  return guidString.split(',').map((item) => item.trim());
}

const GUIDUSER: GuidUserType = {
  rnkim: {
    sectionID: String(process.env.REACT_APP_USER_RNKIM_SECTION_ID),
    userGuid: parseGuidList(process.env.REACT_APP_USER_RNKIM_USER_GUID),
  },
  zakupki_rosneft: {
    sectionID: String(process.env.REACT_APP_USER_ZAKUPKI_ROSNEFT_SECTION_ID),
    userGuid: parseGuidList(process.env.REACT_APP_USER_ZAKUPKI_ROSNEFT_USER_GUID),
  },
  invite_zakupki_rosneft: {
    sectionID: String(process.env.REACT_APP_USER_INVITE_ZAKUPKI_ROSNEFT_SECTION_ID),
    userGuid: parseGuidList(process.env.REACT_APP_USER_INVITE_ZAKUPKI_ROSNEFT_USER_GUID),
  },
  report_region: {
    sectionID: String(process.env.REACT_APP_USER_REGION_REPORT_SECTION_ID),
    userGuid: parseGuidList(process.env.REACT_APP_USER_REGION_REPORT_USER_GUID),
  },
  kim: {
    sectionID: String(process.env.REACT_APP_USER_KIM_REPORT_SECTION_ID),
    userGuid: parseGuidList(process.env.REACT_APP_USER_KIM_REPORT_USER_GUID),
  },
  default: {
    sectionID: '0',
    userGuid: [],
  },
};

export default GUIDUSER;
